import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { PlayerCancelManagerRequest } from "../../redux/auth-reducer/auth-service";
import { readApiMessage } from "../../utils/helper/helper";
import { ManagerIdentity } from "./ManagerIdentity";

/**
 * "Cancel request" (#133): withdraws the player's Pending request to one manager. Nothing is
 * cancelled until "Yes, cancel".
 *
 * onDone(cancelled) is called whenever the server answered. A refusal ("This request has already
 * been answered.") is shown as a toast and still reloads the list, because it means the manager's
 * status has moved on. With no reply the pop-up stays open.
 *
 * @param {{show: boolean, manager: object|null, onClose: () => void, onDone: (cancelled: boolean) => void}} props
 */
export const CancelRequestModal = ({ show, manager, onClose, onDone }) => {
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    const res = await PlayerCancelManagerRequest(manager?.managerId);
    setBusy(false);

    if (res?.data?.status === true) {
      onDone(true);
      return;
    }

    if (res) {
      toast.error(readApiMessage(res));
      if (res.data?.status === false) onDone(false);
    }
  };

  return (
    <Modal show={show} centered onHide={busy ? undefined : onClose}>
      <Modal.Header className="promo-code-header promo-close" closeButton={!busy}>
        <Modal.Title>
          <b>Cancel request</b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to cancel your request for subscription?</p>
        {manager && <ManagerIdentity manager={manager} compact />}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={busy}>
          No
        </Button>
        <Button variant="danger" onClick={confirm} disabled={busy}>
          {busy ? "Cancelling..." : "Yes, cancel"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
